import type { EstimateManagerProductResponse } from '../../../core/models/estimates-orchestrator';
import {
  countRatedSpecialHandlingPieces,
  mapEstimateManagerPricingToEstimatePricing,
} from '../../service-step/sections/delivery-service-selection/build-delivery-service-requests';
import type { SelectedDeliveryService } from '../../service-step/sections/delivery-service-selection/delivery-service-selection.model';

/**
 * Builds the refreshed selected service after a successful pickup-date re-estimate (OM-754).
 * Clears prior coupon discount fields so Review never shows stale discounted totals with a
 * list-price JWT_est; coupon re-apply runs separately when a code is already present.
 */
export function buildSelectedServiceAfterPickupReestimate(
  selectedService: SelectedDeliveryService,
  product: EstimateManagerProductResponse,
  estimateAttestation: string,
): SelectedDeliveryService | null {
  const pricing = mapEstimateManagerPricingToEstimatePricing(product.estimate?.pricing);
  if (!pricing) {
    return null;
  }

  const shipmentDate =
    product.serviceAvailability?.shipmentDate?.trim().replaceAll('/', '-') ||
    selectedService.shipmentDate;
  const deliveryDate =
    product.serviceAvailability?.expectedDeliveryDate?.trim() || selectedService.deliveryDate;
  const transportationMode =
    product.serviceAvailability?.transportationMode?.trim() || selectedService.transportationMode;
  const ratedSpecialHandlingPieceCounts = countRatedSpecialHandlingPieces(product.ratingInput);

  return {
    ...selectedService,
    ...(shipmentDate ? { shipmentDate } : {}),
    ...(deliveryDate ? { deliveryDate } : {}),
    transportationMode,
    pricing,
    discountedPricing: undefined,
    couponDiscount: undefined,
    attestation: estimateAttestation,
    ...(ratedSpecialHandlingPieceCounts
      ? { ratedSpecialHandlingPieceCounts }
      : { ratedSpecialHandlingPieceCounts: undefined }),
  };
}
